/*
 * Public API Surface of microapp-quiz
 */

export * from './lib/microapp-quiz.service';
export * from './pages/microapp-quiz.component';
export * from './lib/microapp-quiz.module';
export * from './pages/microapp-quiz.module';
